import { arraymove } from "../../array";
import { DEFAULT_BIBLE } from "@/shared/utils/content/content.constants";
import { getBookIdNumber } from "@/shared/utils/content/content";

export const filterOptionsAdvSearchByTitle = (options, value) => options.filter((item) => {
  return item.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
});

export const filterOptionsAdvSearchWithBookCode = (options, value) => options.filter((item) => {
  return item.code.toLowerCase().indexOf(value.toLowerCase()) !== -1;
});

export const filterOptionsAdvSearchByTitleAndBookCode = (options, value) => {
  const finalFilteredOptions = [
    ...filterOptionsAdvSearchWithBookCode(options, value),
    ...filterOptionsAdvSearchByTitle(options, value),
  ];
  const index = finalFilteredOptions.findIndex(
    (item) => item?.code?.toLowerCase() === value.toLowerCase()
  );
  if (index !== -1 && index !== 0) {
    arraymove(finalFilteredOptions, index, 0);
  }
  return finalFilteredOptions;
};

export const getBiblePubnr = (baseBible) => {
  if (!baseBible) {
    return parseInt(DEFAULT_BIBLE.en);
  }
  return getBookIdNumber(baseBible);
};

export const cutAreaFromExtras = (oldExtras) => {
  const extras = { ...oldExtras };
  if ("collection" in extras) {
    delete extras["collection"];
  }
  if ("collections" in extras) {
    delete extras["collections"];
  }
  return extras;
};
